import { render, staticRenderFns } from "./placeholder_system_note.vue?vue&type=template&id=8ff41686"
import script from "./placeholder_system_note.vue?vue&type=script&lang=js"
export * from "./placeholder_system_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports